<template>
<div>
  <div v-if="$route.name === 'transaction' || $route.name === 'transaction-statement'" class="header-nav shadow-sm pr-3 pl-3 border-bottom">
      <ul class="nav nav-tabs nav-fill">
          <li class="nav-item">
            <router-link class="nav-link" :to="{ name: 'transaction' }" :class="{ 'active': $route.name === 'transaction' }">รายการล่าสุด</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link" :to="{ name: 'transaction-statement' }" :class="{ 'active': $route.name === 'transaction-statement' }">ขอสเตทเม้นท์</router-link>
          </li>
      </ul>
  </div>
  <router-view></router-view>
</div>
</template>

<script>
export default {
}
</script>

<style lang="scss">
</style>
